'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var reactDates = require('react-dates');
var cx = require('classnames');
var moment = require('moment');
var Button = require('@arrive/button');
var Popover = require('@arrive/popover');
var SVGIcon = require('@arrive/svg-icon');
var ApplyButtonBar = require('@arrive/apply-button-bar');
var TextEntry = require('@arrive/text-entry');
var ARROW_DOWN = require('@arrive/ui-icons/svg/ic_drawer.svg');
var ARROW_LEFT = require('@arrive/ui-icons/svg/ic_left_arrow.svg');
var ARROW_RIGHT = require('@arrive/ui-icons/svg/ic_right_arrow.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var ApplyButtonBar__default = /*#__PURE__*/_interopDefaultLegacy(ApplyButtonBar);
var TextEntry__default = /*#__PURE__*/_interopDefaultLegacy(TextEntry);
var ARROW_DOWN__default = /*#__PURE__*/_interopDefaultLegacy(ARROW_DOWN);
var ARROW_LEFT__default = /*#__PURE__*/_interopDefaultLegacy(ARROW_LEFT);
var ARROW_RIGHT__default = /*#__PURE__*/_interopDefaultLegacy(ARROW_RIGHT);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","quickSelectors":"arrive_DatePicker__quickSelectors","quickButton":"arrive_DatePicker__quickButton","popoverAnchor":"arrive_DatePicker__popoverAnchor","popoverContent":"arrive_DatePicker__popoverContent","noApplyBar":"arrive_DatePicker__noApplyBar","popoverContent__horizontal":"arrive_DatePicker__popoverContent__horizontal","popoverContent__vertical":"arrive_DatePicker__popoverContent__vertical","smallScreen":"arrive_DatePicker__smallScreen","upArrow":"arrive_DatePicker__upArrow","monthText":"arrive_DatePicker__monthText","dayOfWeekContainer":"arrive_DatePicker__dayOfWeekContainer","dayOfWeek":"arrive_DatePicker__dayOfWeek","container":"arrive_DatePicker__container"};

var _excluded = ["children", "className", "date", "endDate", "id", "isRange", "navNext", "navPrev", "offset", "onApplyClick", "orientation", "popoverClasses", "popoverPlacement", "quickButtonClicked", "quickSelectorsId", "screenSizeSmall", "setShowPopover", "showPopover", "showQuickSelectors", "customQuickSelectors", "startDate", "useApplyButtonBar"],
    _excluded2 = ["setShowDatePicker", "showDatePicker", "date", "setDate", "setDateStringValue", "dateStringValue", "dateIANACode", "strictMode"];
var daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var minDateDBSupportedStr = '01/01/1753';
var minDateDBSupportedObj = moment__default["default"](minDateDBSupportedStr);
var formatDate = function formatDate(_ref, includeYear) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate;

  if (startDate === null) {
    return null;
  }

  if (startDate.isSame(endDate, 'day')) {
    var formatStyle = includeYear ? 'MMM D, YYYY' : 'MMM D';
    return startDate.format(formatStyle);
  }

  return "".concat(startDate.format('MMM D'), " - ").concat(endDate.format('MMM D'));
};
var formatSingleDate = function formatSingleDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMMM D, YYYY';

  if (date === null) {
    return null;
  }

  return date.format(format);
};
var isValidDatePickerTextEntry = function isValidDatePickerTextEntry(input) {
  var parsedDate = moment__default["default"](input, ['MM/DD/YYYY', 'M/DD/YYYY', 'MM/D/YYYY', 'M/D/YYYY'], true);
  return parsedDate.isValid() && parsedDate.isSameOrAfter(minDateDBSupportedObj);
};

var DatePicker = function DatePicker(_ref2) {
  var _cx;

  var children = _ref2.children,
      className = _ref2.className,
      date = _ref2.date,
      endDate = _ref2.endDate,
      id = _ref2.id,
      isRange = _ref2.isRange,
      navNext = _ref2.navNext,
      navPrev = _ref2.navPrev,
      offset = _ref2.offset,
      onApplyClick = _ref2.onApplyClick,
      orientation = _ref2.orientation,
      popoverClasses = _ref2.popoverClasses,
      popoverPlacement = _ref2.popoverPlacement,
      quickButtonClicked = _ref2.quickButtonClicked,
      quickSelectorsId = _ref2.quickSelectorsId,
      screenSizeSmall = _ref2.screenSizeSmall,
      setShowPopover = _ref2.setShowPopover,
      showPopover = _ref2.showPopover,
      showQuickSelectors = _ref2.showQuickSelectors,
      customQuickSelectors = _ref2.customQuickSelectors,
      startDate = _ref2.startDate,
      _ref2$useApplyButtonB = _ref2.useApplyButtonBar,
      useApplyButtonBar = _ref2$useApplyButtonB === void 0 ? true : _ref2$useApplyButtonB,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  var _useState = React.useState('startDate'),
      _useState2 = _slicedToArray(_useState, 2),
      focusedInput = _useState2[0],
      setFocusedInput = _useState2[1];

  var _useState3 = React.useState({
    startDate: startDate,
    endDate: endDate
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedDates = _useState4[0],
      setSelectedDates = _useState4[1];

  var _useState5 = React.useState(date),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedDate = _useState6[0],
      setSelectedDate = _useState6[1];

  React.useEffect(function () {
    if (startDate !== selectedDates.startDate || endDate !== selectedDates.endDate) {
      setSelectedDates({
        startDate: startDate,
        endDate: endDate
      });
    }

    if (date !== selectedDate) {
      setSelectedDate(date);
    } // purposefully excluding the internal state from this -- we only care if the received props have changed
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [startDate, endDate, date]);

  var selectCustomQuickSelector = function selectCustomQuickSelector(event, startDateSelector, endDateSelector, idSelector) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var dates = {
      startDate: startDateSelector ? startDateSelector.clone() : null,
      endDate: endDateSelector ? endDateSelector.clone() : null
    };
    setSelectedDates(dates);
    quickButtonClicked(idSelector, dates);
  };

  var selectToday = function selectToday(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var today = moment__default["default"](Date.now());
    var dates = {
      startDate: today.clone(),
      endDate: today.clone()
    };
    setSelectedDates(dates);
    quickButtonClicked('today', dates);
  };

  var selectTomorrow = function selectTomorrow(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var tomorrow = moment__default["default"](Date.now()).add(1, 'd');
    var dates = {
      startDate: tomorrow.clone(),
      endDate: tomorrow.clone()
    };
    setSelectedDates(dates);
    quickButtonClicked('tomorrow', dates);
  };

  var selectThisWeek = function selectThisWeek(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var dates = {
      startDate: moment__default["default"](Date.now()).startOf('week'),
      endDate: moment__default["default"](Date.now()).endOf('week')
    };
    setSelectedDates(dates);
    quickButtonClicked('thisWeek', dates);
  };

  var selectNextWeek = function selectNextWeek(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var nextWeek = moment__default["default"](Date.now()).add(1, 'w');
    var dates = {
      startDate: nextWeek.clone().startOf('week'),
      endDate: nextWeek.clone().endOf('week')
    };
    setSelectedDates(dates);
    quickButtonClicked('nextWeek', dates);
  };

  var handleClear = function handleClear(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var clearData = isRange ? {
      startDate: null,
      endDate: null
    } : null;
    onApplyClick(clearData);
    setShowPopover(false);
  };

  var handleApply = function handleApply(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();

    if (isRange) {
      if (selectedDates.endDate === null) {
        onApplyClick({
          startDate: selectedDates.startDate,
          endDate: selectedDates.startDate
        });
      } else {
        onApplyClick(selectedDates);
      }
    } else {
      onApplyClick(selectedDate);
    }

    setShowPopover(false);
  };

  var onDatesChange = function onDatesChange(newDates) {
    setSelectedDates(newDates);

    if (newDates.endDate !== selectedDates.endDate) {
      // reset the focus to the start date after the user selects an end dates
      // we don't need to do the reverse because DayPickerRangeController does that already
      setFocusedInput('startDate');
    }
  };

  var onDateChange = function onDateChange(newDate) {
    setSelectedDate(newDate);
  };

  React.useEffect(function () {
    if (!useApplyButtonBar) {
      handleApply();
    }
  }, [useApplyButtonBar, selectedDate, selectedDates]);

  var renderMonthElement = function renderMonthElement(_ref3) {
    var month = _ref3.month;
    var monthFormatted = month.format('MMMM YYYY');
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: "datepicker-".concat(monthFormatted)
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: styles.monthText
    }, monthFormatted), /*#__PURE__*/React__default["default"].createElement("div", {
      className: styles.dayOfWeekContainer
    }, daysOfWeek.map(function (day, idx) {
      return /*#__PURE__*/React__default["default"].createElement("li", {
        key: "datepicker-".concat(monthFormatted).concat(day).concat(idx),
        className: styles.dayOfWeek
      }, day);
    })));
  };

  renderMonthElement.displayName = 'renderMonthElement';
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/React__default["default"].createElement(Popover__default["default"], {
    showPopover: showPopover,
    setShowPopover: setShowPopover,
    resolvedClasses: _objectSpread2(_objectSpread2({}, popoverClasses), {}, {
      anchorClass: cx__default["default"](styles.popoverAnchor, popoverClasses && popoverClasses.anchorClass),
      contentContainerClass: cx__default["default"](popoverClasses && popoverClasses.contentContainerClass, (_cx = {}, _defineProperty(_cx, styles.popoverContent, isRange), _defineProperty(_cx, styles.popoverContent__horizontal, !isRange), _defineProperty(_cx, styles.popoverContent__vertical, orientation && orientation === 'vertical'), _defineProperty(_cx, styles.noApplyBar, !useApplyButtonBar), _defineProperty(_cx, styles.smallScreen, screenSizeSmall), _cx))
    }),
    placement: popoverPlacement,
    offset: offset,
    screenSizeSmall: screenSizeSmall,
    popperContent: /*#__PURE__*/React__default["default"].createElement("div", null, screenSizeSmall && /*#__PURE__*/React__default["default"].createElement(ApplyButtonBar.ApplyButtonBarMobile, {
      title: "Choose a date".concat(isRange ? ' or date range' : ''),
      onCancelClick: function onCancelClick() {
        return setShowPopover(false);
      },
      onApplyClick: handleApply
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: cx__default["default"](styles.container, _defineProperty({}, styles.smallScreen, screenSizeSmall))
    }, isRange ? /*#__PURE__*/React__default["default"].createElement(reactDates.DayPickerRangeController, _extends({
      endDate: selectedDates.endDate,
      initialVisibleMonth: function initialVisibleMonth() {
        return startDate || moment__default["default"](Date.now());
      },
      focusedInput: focusedInput,
      minimumNights: 0,
      navPrev: !navPrev ? /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
        svgRef: ARROW_DOWN__default["default"],
        className: styles.upArrow
      }) : navPrev,
      navNext: !navNext ? /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
        svgRef: ARROW_DOWN__default["default"],
        className: styles.navButtonIcon
      }) : navNext,
      onDatesChange: onDatesChange,
      onFocusChange: setFocusedInput,
      renderMonthElement: renderMonthElement,
      startDate: selectedDates.startDate,
      orientation: orientation
    }, restProps)) : /*#__PURE__*/React__default["default"].createElement(reactDates.DayPickerSingleDateController, _extends({
      date: selectedDate,
      focused: true,
      initialVisibleMonth: function initialVisibleMonth() {
        return date || moment__default["default"](Date.now());
      },
      navNext: /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
        svgRef: ARROW_RIGHT__default["default"],
        className: styles.navButtonIcon
      }),
      navPrev: /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
        svgRef: ARROW_LEFT__default["default"],
        className: styles.navButtonIcon
      }),
      onDateChange: onDateChange,
      renderMonthElement: renderMonthElement,
      orientation: orientation
    }, restProps)), showQuickSelectors && /*#__PURE__*/React__default["default"].createElement("div", {
      className: styles.quickSelectors,
      quickSelectorsId: quickSelectorsId
    }, customQuickSelectors && customQuickSelectors.length > 0 ? customQuickSelectors.map(function (selector) {
      return /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
        key: selector.id,
        className: styles.quickButton,
        onClick: function onClick(event) {
          return selectCustomQuickSelector(event, selector.startDate, selector.endDate, selector.id);
        },
        type: "secondary"
      }, selector.label);
    }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: styles.quickButton,
      onClick: selectToday,
      type: "secondary"
    }, "Today"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: styles.quickButton,
      onClick: selectTomorrow,
      type: "secondary"
    }, "Tomorrow"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: styles.quickButton,
      onClick: selectThisWeek,
      type: "secondary"
    }, "This Week"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      className: styles.quickButton,
      onClick: selectNextWeek,
      type: "secondary"
    }, "Next Week")))), !screenSizeSmall && useApplyButtonBar && /*#__PURE__*/React__default["default"].createElement(ApplyButtonBar__default["default"], {
      id: id,
      onClearClick: handleClear,
      onApplyClick: handleApply
    }))
  }, children));
};

var sanitizeDate = function sanitizeDate(input) {
  var invalidCharacteresRegex = /[^\d/]/g;
  var sanitizedDate = input.replace(invalidCharacteresRegex, '');

  var _sanitizedDate$split = sanitizedDate.split('/'),
      _sanitizedDate$split2 = _slicedToArray(_sanitizedDate$split, 3),
      month = _sanitizedDate$split2[0],
      day = _sanitizedDate$split2[1],
      year = _sanitizedDate$split2[2];

  if (year && year.length > 4) {
    year = year.slice(0, 4);
  }

  return [month, day, year].filter(function (el) {
    return el !== undefined;
  }).join('/');
};

var isValidDayAndMonth = function isValidDayAndMonth(input) {
  var inputEntries = input.split('/').filter(function (entry) {
    return !!entry;
  });

  if (inputEntries.length === 2) {
    var _inputEntries = _slicedToArray(inputEntries, 2),
        month = _inputEntries[0],
        day = _inputEntries[1];

    var currentYear = new Date().getFullYear();

    if (day === '0') {
      return true;
    }

    return isValidDatePickerTextEntry("".concat(month, "/").concat(day, "/").concat(currentYear));
  }

  return true;
};
var autoCompleteZero = function autoCompleteZero(date) {
  var newDate = date;
  var firstRegex = new RegExp('^1/$', 'g').test(date);
  var secondRegex = new RegExp('^((0[1-9])|(1[0-2]))/[1-3]/$', 'g').test(date);
  var thirdRegex = new RegExp('^[2-9]$', 'g').test(date);
  var fourthRegex = new RegExp('^((0[1-9])|(1[0-2]))/[4-9]$', 'g').test(date);

  if (firstRegex) {
    newDate = "0".concat(date);
  } else if (secondRegex || fourthRegex) {
    var dateSplit = date.split('/');
    newDate = "".concat(dateSplit[0], "/0").concat(dateSplit[1], "/");
  } else if (thirdRegex) {
    newDate = "0".concat(date, "/");
  }

  return newDate;
};
DatePicker.displayName = 'DatePicker';
DatePicker.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  className: PropTypes__default["default"].string,

  /** momentJS date object OR null */
  date: PropTypes__default["default"].object,
  daySize: PropTypes__default["default"].number,
  enableOutsideDays: PropTypes__default["default"].bool,

  /** momentJS date object OR null */
  endDate: PropTypes__default["default"].object,
  hideKeyboardShortcutsPanel: PropTypes__default["default"].bool,
  id: PropTypes__default["default"].string,
  keepOpenOnDateSelect: PropTypes__default["default"].bool,

  /** optional customized nodes for navigation component */
  navNext: PropTypes__default["default"].node,
  navPrev: PropTypes__default["default"].node,
  noBorder: PropTypes__default["default"].bool,
  numberOfMonths: PropTypes__default["default"].number,
  offset: PropTypes__default["default"].arrayOf(PropTypes__default["default"].number),

  /** ({ startDate, endDate }) => {} */
  onApplyClick: PropTypes__default["default"].func.isRequired,
  orientation: PropTypes__default["default"].string,
  popoverPlacement: PropTypes__default["default"].string,
  quickButtonClicked: PropTypes__default["default"].func,
  quickSelectorsId: PropTypes__default["default"].string,
  showQuickSelectors: PropTypes__default["default"].bool,
  customQuickSelectors: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),

  /** momentJS date object OR null */
  startDate: PropTypes__default["default"].object,
  verticalHeight: PropTypes__default["default"].number,
  screenSizeSmall: PropTypes__default["default"].bool
};
DatePicker.defaultProps = {
  date: null,
  daySize: 32,
  enableOutsideDays: true,
  endDate: null,
  hideKeyboardShortcutsPanel: true,
  keepOpenOnDateSelect: true,
  navNext: null,
  navPrev: null,
  noBorder: true,
  numberOfMonths: 2,
  orientation: 'horizontal',
  popoverPlacement: 'bottom-start',
  quickButtonClicked: function quickButtonClicked() {},
  showQuickSelectors: false,
  customQuickSelectors: [],
  startDate: null,
  verticalHeight: 303,
  screenSizeSmall: false
};
var DatePickerTextEntry = /*#__PURE__*/React__default["default"].forwardRef(function (_ref4, ref) {
  var setShowDatePicker = _ref4.setShowDatePicker,
      showDatePicker = _ref4.showDatePicker,
      date = _ref4.date,
      setDate = _ref4.setDate,
      setDateStringValue = _ref4.setDateStringValue,
      dateStringValue = _ref4.dateStringValue,
      _ref4$dateIANACode = _ref4.dateIANACode,
      dateIANACode = _ref4$dateIANACode === void 0 ? "" : _ref4$dateIANACode,
      _ref4$strictMode = _ref4.strictMode,
      strictMode = _ref4$strictMode === void 0 ? false : _ref4$strictMode,
      props = _objectWithoutProperties(_ref4, _excluded2);

  return /*#__PURE__*/React__default["default"].createElement(TextEntry__default["default"], _extends({
    ref: ref,
    value: dateStringValue,
    onMouseDown: function onMouseDown() {
      setShowDatePicker(!showDatePicker);
    },
    onKeyUp: function onKeyUp(evt) {
      var value = evt.key;

      if (value === 'T' || value === 't') {
        if (dateIANACode) {
          setDate(moment__default["default"]().tz(dateIANACode));
        } else {
          setDate(moment__default["default"]());
        }
      }

      if (value === 'M' || value === 'm') {
        if (dateIANACode) {
          setDate(moment__default["default"]().tz(dateIANACode).add(1, 'd'));
        } else {
          setDate(moment__default["default"]().add(1, 'd'));
        }
      }

      if (value === 'Y' || value === 'y') {
        if (dateIANACode) {
          setDate(moment__default["default"]().tz(dateIANACode).subtract(1, 'd'));
        } else {
          setDate(moment__default["default"]().subtract(1, 'd'));
        }
      }

      if (value === '+' && date) {
        setDate(moment__default["default"](date).add(1, 'd'));
      }

      if (value === '-' && date) {
        setDate(moment__default["default"](date).subtract(1, 'd'));
      }
    },
    onChange: function onChange(evt) {
      var nextValue = evt.target.value;

      if (!nextValue.includes('+') && !nextValue.includes('-') && !nextValue.includes('t') && !nextValue.includes('T')) {
        var dateSanitized = ''; //canAddSlash checks the length of the date and whether or not a slash has been manually added

        nextValue = autoCompleteZero(nextValue);
        var canAddSlash = nextValue.length === 3 && !nextValue.includes('/') || (nextValue.match(/\//g) || []).length === 1 && nextValue.length === nextValue.indexOf('/') + 4;

        if (canAddSlash) {
          dateSanitized = "".concat(nextValue.slice(0, -1), "/").concat(nextValue.slice(-1));
        } else {
          dateSanitized = nextValue;
        }

        var validDayAndMonth = isValidDayAndMonth(dateSanitized);

        if (strictMode) {
          dateSanitized = sanitizeDate(dateSanitized);
        }

        if (validDayAndMonth) {
          setDateStringValue(dateSanitized);
        }

        if (isValidDatePickerTextEntry(dateSanitized)) {
          setDate(moment__default["default"](dateSanitized, ['MM/DD/YYYY', 'M/DD/YYYY', 'MM/D/YYYY', 'M/D/YYYY'], true));
        } else {
          setDate(null);
        }
      }
    },
    onFocus: function onFocus() {
      setShowDatePicker(true);
    },
    onBlur: function onBlur() {
      //on blur functionality allows user to enter just month and day and we will asume the year on blur
      var isValid = moment__default["default"](dateStringValue, ['M/D', 'MM/D', "M/DD", 'MM/DD'], true).isValid();

      if (isValid) {
        setDate(moment__default["default"]("".concat(moment__default["default"](dateStringValue).format('MM/DD'), "/").concat(moment__default["default"]().year()), ['MM/DD/YYYY'], true));
      }
    }
  }, props));
});
DatePickerTextEntry.displayName = 'DatePickerTextEntry';
DatePickerTextEntry.propTypes = {
  setShowDatePicker: PropTypes__default["default"].func.isRequired,
  showDatePicker: PropTypes__default["default"].bool.isRequired,
  date: PropTypes__default["default"].object.isRequired,
  setDate: PropTypes__default["default"].func.isRequired,
  setDateStringValue: PropTypes__default["default"].func.isRequired,
  dateStringValue: PropTypes__default["default"].string.isRequired,
  dateIANACode: PropTypes__default["default"].string,
  strictMode: PropTypes__default["default"].bool
};

exports.DatePickerTextEntry = DatePickerTextEntry;
exports.autoCompleteZero = autoCompleteZero;
exports["default"] = DatePicker;
exports.formatDate = formatDate;
exports.formatSingleDate = formatSingleDate;
exports.isValidDatePickerTextEntry = isValidDatePickerTextEntry;
exports.isValidDayAndMonth = isValidDayAndMonth;
exports.minDateDBSupportedObj = minDateDBSupportedObj;
exports.minDateDBSupportedStr = minDateDBSupportedStr;
